import {AfterViewInit, Component, ElementRef, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {Subject} from "rxjs";
import {ExchangeService} from "@aparraga/ahoracrypto-client-common/src/app/common/exchange/exchange.service";
import {CurrencyService} from "@aparraga/ahoracrypto-client-common/src/app/common/currency/currency.service";
import {CryptoService} from "@aparraga/ahoracrypto-client-common/src/app/common/crypto/crypto.service";
import {ProductService} from "@aparraga/ahoracrypto-client-common/src/app/common/product/product.service";
import {DOCUMENT} from "@angular/common";
import {DeviceDetectorService} from "ngx-device-detector";


import { Modal } from 'flowbite';
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";


@Component({
    templateUrl: './cryptospopup.component.html',
    styleUrls: ['./cryptospopup.component.scss'],
    selector: 'cryptospopup',
    standalone: false
})
export class CryptosPopupComponent implements OnInit, AfterViewInit, OnDestroy{

  @Output() public onCryptoSelected = new Subject<any>();

  @Input() public selectedCrypto = null;

  @ViewChild('cryptoList') protected cryptoListElement: ElementRef<HTMLElement>;

  @ViewChild('searchinput') protected searchInputElement: ElementRef<HTMLElement>;

  public exchangePrices = [];
  protected subscriptions = [];
  public highlightedCryptos = [];

  protected modal;
  public filter = "";

  public constructor(protected exchangeService: ExchangeService,
                     protected cryptoService: CryptoService,
                     protected productService: ProductService,
                     @Inject(IS_BROWSER) protected isBrowser: boolean,
                     @Inject(DOCUMENT) private document: Document,
                     protected deviceService: DeviceDetectorService,
                     protected currencyService: CurrencyService) {

    this.subscriptions.push(this.exchangeService.exchangePricesSubject$.subscribe(prices => {
      this.refreshExchangePrices(prices);
    }));

    this.subscriptions.push(this.currencyService.currencySubject$.subscribe(currency => {
      this.refreshExchangePrices(this.exchangeService.getExchangePrices());
    }));


  }

  ngOnInit() {
    this.refreshExchangePrices(this.exchangeService.getExchangePrices());
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  protected async refreshExchangePrices(exchangePrices) {
    let exchangePricesCollection = [];
    let highlightedCryptosCollection = [];

    let currencyCode = this.currencyService.getSelectedCurrency().code;
    await Object.values(exchangePrices).forEach(async exchangePrice => {
      let symbol = this.exchangeService.getStableCoin(currencyCode);
      if(!!exchangePrice[symbol]) {
        let exchangePriceToAdd = exchangePrice[symbol];
        let product = await this.productService.getProduct(exchangePriceToAdd.baseCurrency);
        if(product?.purchaseable == true) {
          exchangePriceToAdd.name = product.name;
          exchangePricesCollection.push(exchangePriceToAdd);
          if(exchangePriceToAdd.baseCurrency == 'BTC' ||
             exchangePriceToAdd.baseCurrency == 'ETH' ||
             exchangePriceToAdd.baseCurrency == 'SOL' ||
             exchangePriceToAdd.baseCurrency == 'XRP' ||
             exchangePriceToAdd.baseCurrency == 'USDC' ||
             exchangePriceToAdd.baseCurrency == 'USDT' ||
             exchangePriceToAdd.baseCurrency == 'POL') {
            highlightedCryptosCollection.push(exchangePriceToAdd);
          }
        }
      }
    });

    //sort exchangePricesCollection by its symbol property
    exchangePricesCollection.sort((a, b) => {
      if (a.baseCurrency < b.baseCurrency) {
        return -1;
      }
      if (a.baseCurrency > b.baseCurrency) {
        return 1;
      }
      return 0;
    });
    highlightedCryptosCollection.sort((a, b) => {
      if (a.baseCurrency < b.baseCurrency) {
        return -1;
      }
      if (a.baseCurrency > b.baseCurrency) {
        return 1;
      }
      return 0;
    });

    this.exchangePrices = exchangePricesCollection;
    this.highlightedCryptos = highlightedCryptosCollection;

  }

  ngAfterViewInit() {
    if(this.isBrowser) {
      this.modal = new Modal(this.cryptoListElement.nativeElement, {
        backdropClasses: 'bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0',
        onShow: () => {
          this.document.body.classList.add('on-modal');
        },
        onHide: () => {
          this.document.body.classList.remove('on-modal');
        }
      });
    }
  }

  show() {
    this.modal.show();
    if(!this.deviceService.isMobile()) {
      this.searchInputElement.nativeElement.focus();
    }
  }

  hide() {
    this.modal.hide();
  }

  selectCrypto(crypto) {
    this.selectedCrypto = crypto.baseCurrency;
    this.cryptoService.setSelectedCrypto(crypto);
    this.onCryptoSelected.next(this.selectedCrypto);
    this.hide();
  }


}
